// extracted by mini-css-extract-plugin
module.exports = {"title":"title___1cVEr","flexEnd":"flexEnd___1U4e3","des":"des___1C0M1","topic":"topic___U_fRt"};